module.exports = __webpack_public_path__ + "static/media/visual-icon-round.fbb4deb9.png";